const { v4: uuidv4 } = require('uuid')

const generateUUID = async () => {
   return await uuidv4()
}

export default generateUUID